import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config"; // adjust path as needed
import FundraiserHeaderComponent, {
  getBackgroundIconFromPurpose,
} from "../../../components/CustomOrganizationsMainView/FundraiserHeader";
import ProductPreview from "../../../components/CustomOrganizationsMainView/product_preview.png";
import custom_product_preview from "../../../components/CustomOrganizationsMainView/santa_margarita_product_preview.png";
import SignupForm from "../../../components/Forms/Signup/SignupForm";
import SigninForm from "../../../components/Forms/Signup/SignInForm";
import { FundraiserCodeResponse } from "../../../Interfaces/Fundraiser";

const CustomOrganizationMamFamAuth = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false); // Only used for SigninForm
  const [fundraiser, setFundraiser] = useState<FundraiserCodeResponse | null>(
    null
  );
  const { fundraiserID, type } = useParams();
  const backgroundIcon = getBackgroundIconFromPurpose(
    fundraiser?.fundraiser_purpose_message
  );
  const navigate = useNavigate();

  const styles = {
    pageWrapper: (
      backgroundColor: string | undefined,
      backgroundImage?: string
    ) => ({
      backgroundColor: backgroundColor || "#ffffff",
      backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
      backgroundRepeat: "repeat",
      backgroundSize: "220px 220px", // Size bigger than the actual image
      backgroundPosition: "center", // Keeps consistent spacing
      minHeight: "100vh",
      padding: "2rem",
    }),
    contentContainer: {
      maxWidth: "800px",
      margin: "0 auto",
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "2rem",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    },
    productImage: {
      maxWidth: "100%",
      height: "auto",
      marginTop: "1rem",
    },
  };

  useEffect(() => {
    const fetchFundraiser = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}fundraiser/${fundraiserID}/`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setFundraiser(data);
      } catch (error) {
        console.log("Error fetching fundraiser:", error);
      }
    };

    document.title =
      type === "signup" ? "Fundraiser Signup" : "Fundraiser Signin";
    fetchFundraiser();
  }, [fundraiserID, type]);

  return (
    <div style={styles.pageWrapper(fundraiser?.primary_color, backgroundIcon)}>
      <div style={styles.contentContainer}>
        {fundraiser && <FundraiserHeaderComponent fundraiser={fundraiser} />}
        <div className="card-body text-center">
          {type === "signup" ? (
            <>
              <SignupForm
                setIsLogin={setIsLogin}
                signUpReroute={`/signup/${fundraiserID || "defaultID"}/signin/`}
              />
              <button
                onClick={() => navigate(`/signup/${fundraiserID || ""}/signin`)}
              >
                Already have an account?
              </button>
            </>
          ) : (
            <>
              <SigninForm
                setIsLogin={setIsLogin}
                setForgotPassword={setIsForgotPassword}
                fundraiserID={fundraiserID || "defaultID"}
              />
              <button
                onClick={() => navigate(`/signup/${fundraiserID || ""}/signup`)}
              >
                Need to create an account?
              </button>
            </>
          )}

            <img
            src={fundraiser?.fundraiser_product_preview || ProductPreview}
            alt="Product Preview"
            style={styles.productImage}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomOrganizationMamFamAuth;
